// src/components/layout/DashboardLayout.js
import React, { useState } from "react";
import { Box, CircularProgress, Drawer } from "@mui/material";
import { useAuth } from "../../contexts/AuthContext";
import Header from "./Header";
import Sidebar from "./Sidebar";
import ServiceWindowAnnouncement from "./ServiceWindowAnnouncement";

const DashboardLayout = ({ children }) => {
	const { loading } = useAuth();
	const [sidebarOpen, setSidebarOpen] = useState(false);

	const toggleSidebar = () => {
		setSidebarOpen(!sidebarOpen);
	};

	if (loading) {
		return (
			<Box
				display="flex"
				justifyContent="center"
				alignItems="center"
				minHeight="100vh"
				sx={{ backgroundColor: "#f3f4f6" }}>
				<CircularProgress size={24} />
			</Box>
		);
	}

	return (
		<Box
			sx={{ display: "flex", backgroundColor: "#f3f4f6", minHeight: "100vh" }}>
			{/* Desktop Sidebar */}
			<Box sx={{ display: { xs: "none", md: "block" } }}>
				<Sidebar />
			</Box>

			{/* Mobile Sidebar (Drawer) */}
			<Drawer
				anchor="left"
				open={sidebarOpen}
				onClose={() => setSidebarOpen(false)}
				sx={{
					display: { xs: "block", md: "none" },
					"& .MuiDrawer-paper": { width: "280px" },
				}}>
				<Sidebar mobile onClose={() => setSidebarOpen(false)} />
			</Drawer>

			<Box sx={{ flexGrow: 1, maxWidth: "100%", minWidth: 0 }}>
				<Header toggleSidebar={toggleSidebar} />
				<Box
					sx={{
						mt: "48px",
						ml: { xs: 0, md: "200px" },
						width: { xs: "100%", md: "calc(100% - 200px)" },
						minWidth: 0,
						p: 2,
					}}>
					<ServiceWindowAnnouncement />
					{children}
				</Box>
			</Box>
		</Box>
	);
};

export default DashboardLayout;
